import {PageResponse} from '..';
import {Player} from './project-player';
import {Transaction} from './transaction';
import {Session} from './session';
import {User} from './user';

export class Accusation {
  id?: string;
  accusationType?: AccusationType;
  confidence?: string;
  evidenceSummary?: string;
  evidenceToRender?: string;
  player?: Player;
  session?: Session;
  transaction?: Transaction;
  reporter?: User;
  creationDate?: Date;
}


export class AccusationResponse extends PageResponse {
  content: Accusation[];
}

export class AccusationType {
  id: string;
  name: string;
  severityRating: string;
}
